import EqManList from "./components/List"
import EqManForm from "./components/Form"

let module = "equipment-manufacturers"

export default [
  { path: "equipment-manufacturers", component: EqManList, meta: { module: module, permissions: ["equipment-access"] } },
  {
    path: "equipment-manufacturers/create",
    component: EqManForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
  {
    path: "equipment-manufacturers/edit/:id",
    component: EqManForm,
    props: true,
    meta: { module: module, permissions: ["equipment-access"] }
  },
]
